import { memo } from 'react';

import type { ContentBlock } from '@/types/newsService';

interface Props {
  block: ContentBlock;
}

export const CalloutBlock = memo(function CalloutBlock({ block }: Props) {
  if (!block.text) return null;

  return (
    <aside className="my-3 rounded-lg border-l-[3px] border-brand bg-brand/10 p-4">
      <p className="whitespace-pre-line text-[15px] leading-6 text-fg">{block.text}</p>
    </aside>
  );
});
